var exports = {
  "vK": "x31de4314--5987ab--banner",
  "wx": "x31de4314--5987ab--header",
  "Qq": "x31de4314--5987ab--text",
};

module.exports = exports;
